import { createApp } from 'vue'
import App from './App.vue'
import './styles/common.css'

createApp(App).mount('#app')
